module.exports = __webpack_public_path__ + "static/img/arrow_back.2d6b0d58.svg";